import React, { useEffect, useState } from 'react';
import { DatePicker, Col, Form, FormInstance, Grid, Message, Row, Schema } from "rsuite";
import { TimeTypeStoryChapterTask, UpsertTimeTypeStoryChapterTask } from '@/models/story-chapter-task.model';
import ZonedDatePicker from '@/components/ZonedDatePicker';

const modelSchema = Schema.Model<UpsertTimeTypeStoryChapterTask>({
  startTime: Schema.Types.DateType().isRequired('This field is required.'),
  endTime: Schema.Types.DateType().isRequired('This field is required.'),
});
const emptyModel: UpsertTimeTypeStoryChapterTask = {
  startTime: undefined,
  endTime: undefined,
};

interface TimeTypeTaskFormFormProps{
  formObject?: TimeTypeStoryChapterTask;
  onFormChange: (formValue: any) => void;
  formRef: React.Ref<FormInstance<Record<string, any>>>;
  loading: number;
}

const TimeTypeTaskForm: React.FC<TimeTypeTaskFormFormProps> = ({ formObject, onFormChange, formRef, loading }) => {
  const [formValue, setFormValue] = useState<UpsertTimeTypeStoryChapterTask>(emptyModel);
  
  useEffect(() => {
    if (formObject) {
      setFormValue(formObject);
    } else {
      setFormValue(emptyModel);
    }
  }, [formObject]);

  useEffect(() => {
    onFormChange(formValue);
  }, [formValue]);
  
  return (
    <Form name='upsert-time-task-type' fluid
        ref={formRef}
        formValue={formValue}
        model={modelSchema}
        disabled={!!loading}
    >    
      <Grid w='100%' fluid>
        <Row>
          <Col span={{xs:24, lg:12}}>
            <Form.Group controlId="startTime">
              <Form.Label>Start Time</Form.Label>
              <Form.Control accepter={DatePicker} block
                format="HH:mm:ss"
                name="startTime" 
                value={formValue.startTime ?? null}
                onChange={dt => setFormValue(pre => ({...pre, startTime: dt ?? undefined}))}
              />              
            </Form.Group>
          </Col>
          <Col span={{xs:24, lg:12}}>
            <Form.Group controlId="endTime">
              <Form.Label>Start Time</Form.Label>
              <Form.Control accepter={DatePicker} block
                format="HH:mm:ss"
                name="endTime" 
                value={formValue.endTime ?? null}
                onChange={dt => setFormValue(pre => ({...pre, endTime: dt ?? undefined}))}
              />              
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Message showIcon type="info">
            User should run at this period of time. Amount is duration of activity in this period in minute.
          </Message>
        </Row>         
      </Grid>
    </Form>
  );
};

export default TimeTypeTaskForm;